import React, { useState } from "react";
import axios from "../utils/axios";
import styles from "../styles/Login.module.scss";
import ChatIcon from "../icons/Chat";
import { Button, FormCard, TextField } from "@suralink/samurai/ui";
import { SuraLogoWithText } from "@suralink/samurai/visuals";
import { Link } from "react-router-dom";
import BrandingContent from "../components/shared/BrandingContent/BrandingContent";

const RequestResetPassword: React.FC = (props: any) => {
  if (!props.location.state) props.location.state = {};
  // these should get passed in from the login component on redirect
  const { coBrandingEnabled, search } = props.location.state;
  let { clientId, redirectUri, state } = props.location.state;

  const [emailSent, setEmailSent] = useState(false);
  const [email, setEmail] = useState("");

  async function sendEmail(): Promise<void> {
    if (!clientId) clientId = "";
    if (!redirectUri) redirectUri = "";

    await axios
      .post("/user/password/reset", {
        email,
        clientId,
        redirectUri,
        state,
      })
      .then(() => {
        setEmailSent(true);
        setEmail("");
      })
      .catch((e) => {
        console.log(e);
      });
  }

  const handleOpenChat = () => {
    const chatUrl = `https://v2.zopim.com/widget/livechat.html?key=2AekYJAlcSZCOOwpwwxkRyIkGeHIDfty&api_calls=[["concierge.setName",["Suralink Support"]],["concierge.setTitle",["Suralink Support"]],["theme.reload",[]],["theme.reload",[]]]&hostname=${window.location.href}&lang=en`;
    window.open(
      chatUrl,
      "_blank",
      "location=yes,height=570,width=440,scrollbar=yes,status=yes"
    );
  };

  return (
    <div className={styles.resetMain}>
      <div className={styles.resetContainer}>
        <div className={styles.marketing}>
          <BrandingContent />
        </div>
        <div
          className={styles.resetPassword}
          onKeyDown={(e: React.KeyboardEvent) => {
            if (e.keyCode === 13) {
              sendEmail();
            }
          }}
        >
          <FormCard
            style={{
              border: "none",
              margin: 0,
              padding: "45px",
              minHeight: "650px",
            }}
          >
            <div className={styles.logo}>
              <SuraLogoWithText />
            </div>

            <hr />

            <div className={styles.resetText}>
              {emailSent ? (
                <div className={styles.emailSuccess}>
                  <h3>We've sent you an email with reset instructions.</h3>
                  <p>
                    If you don’t see the password reset email after 10 minutes,
                    check your spam folder.
                  </p>
                </div>
              ) : (
                <p>
                  Enter the email associated with your Suralink account and we
                  will send you recovery instructions.
                </p>
              )}
            </div>
            <TextField
              style={{
                width: "428px",
                margin: "auto",
              }}
              placeholder="email address"
              label="Email address"
              required
              // showRequiredState={formErr}
              requiredText="This field is not optional"
              onChange={(e: any) => {
                setEmail(e.target.value.trim());
              }}
              type="email"
              name="email"
              value={email}
            />
            <Button
              label="Send password reset email"
              type="submit"
              className={styles.loginBtn}
              color="blue"
              disabled={!email.includes("@")}
              style={{
                width: "428px",
                margin: "32px auto 24px",
                height: "40px",
              }}
              onClick={() => {
                sendEmail();
              }}
            />

            {clientId && redirectUri && (
              <div className={styles.remembered}>
                <span>
                  Suddenly remembered?
                  <p>
                    <Link
                      to={{
                        pathname: "/login",
                        search,
                      }}
                    >
                      {" "}
                      Sign in now
                    </Link>
                  </p>
                </span>
              </div>
            )}

            <hr
              style={{
                margin: `${coBrandingEnabled ? "36px auto" : "40px auto"}`,
              }}
            />

            <div className={styles.btn} onClick={handleOpenChat}>
              Live chat support
              <span style={{ position: "relative", left: "8px", top: "1px" }}>
                <ChatIcon fillColor="#2a5a8c" />
              </span>
            </div>
          </FormCard>
        </div>
      </div>
    </div>
  );
};

export default RequestResetPassword;
